module.exports = __webpack_public_path__ + "static-portal/img/logo.e085d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 4